export default "__VITE_ASSET__BD3l_2KB__"